export const messages = state => state.message.messages
export const userinfo = state => state.user.userinfo
export const roominfo = state => state.chatroom.chatroom



// WEBPACK FOOTER //
// ./src/vuex/getters.js